module.exports = __webpack_public_path__ + "static/media/chris-traits-comparisons.6f9282ae.png";